(function(){
  "use strict";
  var bars = document.querySelectorAll('[data-dv-sticky]');
  if (!bars.length) return;
  Array.prototype.forEach.call(bars, function (bar) {
    if (bar.hasAttribute('data-follow-primary')) {
      var root = bar.closest('.dv-funnel');
      var primary = root && root.querySelector('.dv-hero .tgbc-buybox__cta');
      if (!primary) return;
      var footer = document.querySelector('.dv-sticky-stop') || document.querySelector('footer.tgb-footer, .shopify-section-group-footer-group footer') || document.querySelector('footer');
      var pending = false;
      function updatePrimaryVisibility() {
        pending = false;
        var rect = primary.getBoundingClientRect();
        var header = document.querySelector('sticky-header');
        var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        var primaryVisible = rect.width > 0 && rect.top >= headerBottom && rect.bottom <= window.innerHeight;
        var pageFooter = document.querySelector('footer.tgb-footer, .shopify-section-group-footer-group footer') || footer;
        var footerRect = pageFooter && pageFooter.getBoundingClientRect();
        var atFooter = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
        var show = !primaryVisible && !atFooter;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
      }
      function schedulePrimaryVisibility() {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(updatePrimaryVisibility);
      }
      if ('IntersectionObserver' in window) {
        var visibilityObserver = new IntersectionObserver(schedulePrimaryVisibility, { threshold: [0, 1] });
        visibilityObserver.observe(primary);
        if (footer) visibilityObserver.observe(footer);
      }
      window.addEventListener('scroll', schedulePrimaryVisibility, { passive: true });
      window.addEventListener('resize', schedulePrimaryVisibility, { passive: true });
      updatePrimaryVisibility();
      return;
    }
    var off = parseInt(bar.getAttribute('data-offset'), 10);
    if (isNaN(off)) off = 480;
    var foot = document.querySelector('.dv-sticky-stop') || document.querySelector('footer');
    var atFoot = false;
    function apply(){
      bar.classList.toggle('is-on', window.pageYOffset > off && !atFoot);
    }
    if ('IntersectionObserver' in window && foot) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { atFoot = e.isIntersecting; });
        apply();
      }, { threshold: 0.15 }).observe(foot);
    }
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply, { passive: true });
    apply();
  });
})();

/* Hero gallery: clicking a thumbnail swaps the main image.
   Delegated from document so theme-editor block re-renders keep working. */
(function(){
  "use strict";
  function selectGalleryImage(root, thumb) {
    var main = root.querySelector('.dv-hero__main img');
    var full = thumb.getAttribute('data-full');
    if (!main || !full) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = full;
    main.alt = thumb.getAttribute('data-alt') || '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-dv-thumb]'), function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    if (thumb.scrollIntoView) {
      thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }
  document.addEventListener('click', function (ev) {
    var nav = ev.target && ev.target.closest ? ev.target.closest('[data-dv-gallery-nav]') : null;
    if (nav) {
      var navRoot = nav.closest('[data-dv-gallery]');
      var thumbs = navRoot ? Array.prototype.slice.call(navRoot.querySelectorAll('[data-dv-thumb]')) : [];
      if (!thumbs.length) return;
      var current = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
      var direction = nav.getAttribute('data-dv-gallery-nav') === 'prev' ? -1 : 1;
      var next = (current + direction + thumbs.length) % thumbs.length;
      selectGalleryImage(navRoot, thumbs[next]);
      return;
    }
    var thumb = ev.target && ev.target.closest ? ev.target.closest('[data-dv-thumb]') : null;
    if (!thumb) return;
    var root = thumb.closest('[data-dv-gallery]');
    if (!root) return;
    selectGalleryImage(root, thumb);
  });
})();
